import {useState, useEffect} from 'react';
import CircularProgress from '@proofpoint/fuse/components/CircularProgress';
import Backdrop from '@mui/material/Backdrop'

const inlineStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  padding: '10px 0',
  zIndex: '9999',
};

const Loading = ({show=true}) => {
  const [open, setOpen] = useState(true);
  const handleClose = () => {
    setOpen(false);
  };
  useEffect(()=>{
    setOpen(show);
  }, [show]);
  return (
    <Backdrop style={inlineStyle} open={open} onClick={handleClose}>
      <CircularProgress size="large" />
    </Backdrop>
  );
};

export default Loading;
